import React from "react";
import { FileText, MessageSquareQuote, Compass, ArrowRight } from "lucide-react";

const CANDIDATE_IMAGE =
  "https://images.unsplash.com/photo-1776178320222-2ad294a75948?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjAzNDR8MHwxfHNlYXJjaHwzfHxmcmllbmRseSUyMG1lbnRvciUyMG9mZmljZXxlbnwwfHx8fDE3NzczNjE2MzZ8MA&ixlib=rb-4.1.0&q=85";

const services = [
  {
    icon: FileText,
    title: "CV Building",
    desc: "A sharper, ATS-friendly CV that highlights the right strengths for the role you want.",
    cta: "Upgrade Your CV",
  },
  {
    icon: MessageSquareQuote,
    title: "Interview Preparation",
    desc: "Mock interviews, tailored feedback and role-specific prep so you walk in confident.",
    cta: "Prepare for Interviews",
  },
  {
    icon: Compass,
    title: "Career Guidance",
    desc: "1:1 support to help you pick the right next move — from first job to a career pivot.",
    cta: "Get Started",
  },
];

export default function ServicesCandidates() {
  return (
    <section
      id="for-candidates"
      className="py-20 md:py-28 bg-brand-surfaceAlt"
      data-testid="services-candidates-section"
    >
      <div className="max-w-7xl mx-auto px-5 sm:px-8">
        <div className="grid lg:grid-cols-12 gap-10 items-end">
          <div className="lg:col-span-7">
            <span className="uppercase text-xs tracking-[0.22em] font-bold text-brand-primary">
              For Candidates
            </span>
            <h2 className="mt-3 font-heading font-medium text-3xl sm:text-4xl lg:text-5xl tracking-tight">
              Friendly, practical support —
              <br className="hidden sm:block" /> for the career you actually want.
            </h2>
            <p className="mt-4 text-brand-muted leading-relaxed max-w-2xl">
              Whether you’re a fresher or have 0–5 years of experience, we’ll help you
              present your best self and land a role that’s right for you.
            </p>
          </div>
          <div className="lg:col-span-5 hidden lg:block">
            <div className="rounded-3xl overflow-hidden border border-brand-border shadow-md">
              <img
                src={CANDIDATE_IMAGE}
                alt="Interview preparation and CV coaching"
                className="w-full h-64 object-cover"
                loading="lazy"
              />
            </div>
          </div>
        </div>

        <div className="mt-12 grid grid-cols-1 md:grid-cols-3 gap-6">
          {services.map(({ icon: Icon, title, desc, cta }, i) => (
            <div
              key={title}
              className="rounded-3xl p-8 bg-white/80 backdrop-blur border border-brand-border hover:-translate-y-1 hover:shadow-md transition-all duration-300"
              data-testid={`candidate-service-card-${i}`}
            >
              <div className="w-12 h-12 rounded-xl bg-brand-soft grid place-items-center text-brand-primary">
                <Icon size={22} />
              </div>
              <h3 className="mt-6 font-heading text-xl font-medium">{title}</h3>
              <p className="mt-3 text-brand-muted leading-relaxed text-sm">{desc}</p>
              <a
                href="#contact"
                className="mt-6 inline-flex items-center gap-2 text-sm font-semibold text-brand-primary"
                data-testid={`candidate-service-cta-${i}`}
              >
                {cta} <ArrowRight size={14} />
              </a>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
